import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { SectionHeading } from './SectionHeading';
import { CheckIcon, CrossIcon, CrownIcon } from './icons/GoldIcons';
const ease = [0.23, 1, 0.32, 1] as const;
export function WhyWeWin() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-ink-900 py-24 sm:py-32" data-id="element-379" data-mp="2t8h5ri69ha1v">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-380" data-mp="3qv6dm8nnagvn">
        <SectionHeading eyebrow={t.whyWeWin.eyebrow} title={t.whyWeWin.title} data-id="element-381" data-mp="3qwr9q2ply7vm" />

        <div className="mt-14 overflow-hidden rounded-3xl border border-gold-deep/30" data-id="element-382" data-mp="3lw3m7r0l8965">
          <div className="grid grid-cols-2 border-b border-gold-deep/30 bg-ink-800" data-id="element-383" data-mp="3h3k72pm955z8">
            <div className="px-6 py-5 text-[11px] uppercase tracking-[0.22em] text-neutral-500 sm:px-8" data-id="element-384" data-mp="3c6jxw5u3vn3w">
              {t.whyWeWin.othersHeader}
            </div>
            <div className="flex items-center gap-2.5 border-l border-gold-deep/30 px-6 py-5 sm:px-8" data-id="element-385" data-mp="8p1ty9hgf08r">
              <CrownIcon className="h-4 w-4 text-gold-bright" strokeWidth={1.5} data-id="element-386" data-mp="14rgidi07ov62" />
              <span className="text-[11px] uppercase tracking-[0.22em] text-gold-bright" data-id="element-387" data-mp="14tu7zbc4hf68">
                {t.whyWeWin.reinaHeader}
              </span>
            </div>
          </div>

          {t.whyWeWin.rows.map((row, index) => <motion.div key={row.reina} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          ease,
          delay: Math.min(index * 0.04, 0.24)
        }} className="grid grid-cols-2 border-b border-gold-deep/15 last:border-b-0" data-id="element-388" data-mp="100hyk8g0ley2" data-mpi={index}>
              <div className="flex items-start gap-3 px-6 py-5 sm:px-8" data-id="element-389" data-mp="h1413gj2tm2t">
                <CrossIcon className="mt-0.5 h-4 w-4 shrink-0 text-neutral-600" strokeWidth={1.6} data-id="element-390" data-mp="26h3ej9tq9xo9" />
                <span className="text-[15px] text-neutral-500" data-id="element-391" data-mp="2bfn2ffrvtjj9">{row.others}</span>
              </div>
              <div className="flex items-start gap-3 border-l border-gold-deep/25 bg-gold-deep/[0.07] px-6 py-5 sm:px-8" data-id="element-392" data-mp="29103sq2qz3ef">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-bright" strokeWidth={1.8} data-id="element-393" data-mp="24zeq52ie2l36" />
                <span className="text-[15px] text-neutral-100" data-id="element-394" data-mp="201mqfmbi5uof">{row.reina}</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}